/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

const React = require('react')
const { ConfigProvider } = require('antd')

/**
 * Wrap root element with Ant Design ConfigProvider for client-side
 */
exports.wrapRootElement = ({ element }) => {
  return React.createElement(
    ConfigProvider,
    {
      theme: {
        token: {
          colorPrimary: '#0A65A8',
        },
      },
    },
    element
  )
}
